<template>
  <div class="overview-box" ref="overview-box" v-loading="loading">
    <Table :dataset="dataset.unArch" @itemCheck="findTask" v-if="dataset.unArch.length > 0"></Table>
    <Gantt :dataset="dataset" :normal="true" :tooltipContent="tooltipContent" :itemCheck="itemCheck" v-if="dataset.unArch.length > 0"></Gantt>
    <nothing v-if="!loading && dataset.unArch.length === 0"></nothing>
  </div>
</template>
<script>
import Table from './table'
import api from '@/services/api/task/task'
import Gantt from '@/views/task/taskSuper/ganttNew/main'
import bus from '@/bus'
export default {
  props: ['checkNode'],
  components: {
    Table,
    Gantt
  },
  watch: {
    checkNode: {
      handler() {
        this.depart_id = this.checkNode ? this.checkNode.data.depart_id : 0
        this.userProjectProgressOverview()
      },
      immediate: true
    },
  },
  mounted() {
    this.windowAddMouseWheel()
  },
  data() {
    let _this = this
    return {
      depart_id: '',
      loading: true,
      dataset: {
        unArchClose: false,
        archClose: false,
        unArch:[],
        arch: [],
      },
      tooltipContent: (item) => {
        return `
        <div class="overview-tip">
          <div class="title">${item.task_name}</div>
          ${item.user ? `<div class="content"><span>负责人</span>${item.user}</div>` : ''}
          <div class="content"><span>开始</span><p>${item.start_time}</p></div>
          <div class="content"><span>截止</span><p>${item.end_time}</p></div>
        </div>
        `
      },
      itemCheck: _this.findTask
    }
  },
  methods: {
    async userProjectProgressOverview() {
      if (!this.depart_id) {
        this.loading = false
        return
      }
      this.loading = true
      let params = {
        number: 999,
        page: 1,
        depart_id: this.depart_id
      }
      let result = await api.userProjectProgressOverview(params)
      if (result.data) {
        result.data.map(item => {
          item.title = item.realname
          item.task_list_id = item.uid
          item.tasks = item.projects.map(res => {
            res.manage_employee_permission = item.manage_employee_permission
            return {
              project_id: res.project_id,
              task_name: res.title,
              start_time: res.task_start_time,
              end_time: res.task_end_time,
              data: res
            }
          })
        })
      }
      this.dataset.unArch = result.data || []
      this.loading = false
    },
    windowAddMouseWheel() {
      var scrollFunc = (e) => {
        e = e || window.event;
        e.preventDefault();
        e.stopPropagation();
        let value = ''
        let n = -1
        if (e.wheelDelta) {  //判断浏览器IE，谷歌滑轮事件
          value = e.wheelDelta
          value > 0 ? n = -1 : n = 1
        } else if (e.detail) {  //Firefox滑轮事件
          value = e.detail
          value > 0 ? n = 1 : n = -1
        }
        let seep = 2
        let timer = setInterval(() => {
          if (seep >= 14) {
            clearInterval(timer)
            return
          }
          bus.$emit('changeTableScroll', seep * n)
          seep = seep + 2
        }, 20)
      }
      //给页面绑定滑轮滚动事件
      let ele = this.$refs['overview-box']
      if (ele) {
        ele.addEventListener('DOMMouseScroll', scrollFunc, false);
        //滚动滑轮触发scrollFunc方法
        ele.onmousewheel = scrollFunc;
      }
    },
    findTask(result) {
      if(!result.data.manage_employee_permission) return
      this.$router.push(`/task?projectId=${result.data.project_id}&isTabShow=true`)
    },
  }
}
</script>
<style lang="scss">
.overview-tip {
  width: 168px;
  .title {
    font-size: 14px;
  }
  .content {
    display: flex;
    align-items: center;
    font-size: 12px;
    margin-top: 16px;
    span {
      color: rgba(32, 32, 32, 0.6);
      display: inline-block;
      width: 40px;
    }
  }
}
.overview-box {
  display: flex;
  padding: 0 !important;
}
</style>
